import axiosV2, { apiPost } from '../core/http/axios_api_v2';


export default {

     
    messagesAwaitingAck: {},

    
    activeChats:{},



    getStatus() {

        return axiosV2('whatsapp/getStatus').then(res => {

            let phone = res && res.data && res.data.phone;

            if (phone) {
                //connected: clear the miss counter and show the phone number
                planup.$store.state.whatsappStatusMisses = 0;
                planup.$store.state.whatsappStatus = phone + ' מחובר';
                planup.$store.state.whatsappConnected = true;
                localStorage.removeItem('planupWhatsappDisconnected');
                return;
            }

            //a clean response with no phone IS a definitive "not connected", so resolve the
            //raw status string immediately — pages the user explicitly opens (settings, chat)
            //show it at once instead of sitting on a spinner while the debounce below runs.
            planup.$store.state.whatsappStatus = 'לא מחובר';

            //the always-visible header warning is debounced separately: a single miss is
            //usually just a transient Baileys reconnect window, so only flip the header's
            //whatsappConnected=false after 3 consecutive misses. Once confirmed, remember it
            //in localStorage so a page refresh shows the warning immediately instead of
            //restarting the debounce from "unknown".
            planup.$store.state.whatsappStatusMisses = (planup.$store.state.whatsappStatusMisses || 0) + 1;
            if (planup.$store.state.whatsappStatusMisses >= 3) {
                planup.$store.state.whatsappConnected = false;
                localStorage.setItem('planupWhatsappDisconnected', '1');
            }

            this.maybeShowDisconnectedPopup();

        }).catch(() => {

            //network/other error: we don't actually know the state, so treat it as a miss
            //for the debounced header signal rather than an instant disconnect. Only after
            //3 consecutive misses do we resolve to disconnected (both the header flag and the
            //raw status string, so a persistent outage doesn't spin the settings page forever).
            planup.$store.state.whatsappStatusMisses = (planup.$store.state.whatsappStatusMisses || 0) + 1;
            if (planup.$store.state.whatsappStatusMisses >= 3) {
                planup.$store.state.whatsappStatus = 'לא מחובר';
                planup.$store.state.whatsappConnected = false;
                localStorage.setItem('planupWhatsappDisconnected', '1');
            }

            this.maybeShowDisconnectedPopup();

        });

    },


    //"a device used to be linked here and now it isn't" — say so clearly, once per browser
    //session, and offer the way to the whatsapp settings tab. whatsappEverConnected is the
    //durable marker (survives loggedOut, which clears whatsappServer); checking whatsappServer
    //too covers sessions whose store predates the marker.
    maybeShowDisconnectedPopup() {

        if (planup.$store.state.whatsappConnected !== false)
            return;

        let businessSettings = planup.$store.state.businessSettings;

        if (!businessSettings || (!businessSettings.whatsappEverConnected && !businessSettings.whatsappServer))
            return;

        if (sessionStorage.getItem('planupWaDisconnectedPopupShown'))
            return;

        sessionStorage.setItem('planupWaDisconnectedPopupShown', '1');

        planup.$swal({
            title: 'חיבור הואצאפ נותק',
            html: 'המכשיר שהיה מחובר למערכת כבר אינו מחובר.<br>' +
                'הודעות ואצאפ לא יישלחו עד לחיבור מחדש - בינתיים הן נשמרות בתור ההודעות.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'מעבר להגדרות ואצאפ',
            cancelButtonText: 'לא כרגע',
        }).then(() => {
            planup.$router.push('/settings?activeTab=orginizationSettings_whatsappTab').catch(() => { });
        }).catch(() => { });

    },


    getNumberInfo(){
        let number = window.prompt('תרשום מספר טלפון כמו 0544636433');
        return axiosV2(`whatsapp/getNumberInfo/${number}`).then(res=>{
            document.write(`<pre>${res.data}</pre>`);
        })
    },

    sendMessage(to, msg) {

        if (!msg) {
            msg = prompt('מה לשלוח?');
        }

        let formattedNumber = to.slice(0, 2) == '05' ? to.slice(1) : to;


        let messageId = `${Math.floor(Math.random() * 1000000)}-${Date.now()}`;

        apiPost(`whatsapp/sendMessage`, { to: formattedNumber, msg, messageId }, true)




        let messageToReturn = {
            message: msg,
            messageId: messageId,
            incomingFromCustomer: false,
            created: new Date(),
            typeOfMessage:'whatsapp',
            gotWhatsappAck: false,
            createdLocally: true
        }


        this.messagesAwaitingAck[messageId] = messageToReturn;

        return messageToReturn;


    },

    getQr() {
        return axiosV2('whatsapp/getQr').then(res => {
            return res.data
        })
    },

    //quiet=true suppresses the global green "הפעולה התבצעה בהצלחה" notification — callers that
    //show the picture itself (the summary strip's refresh badge) don't want a success toast on a
    //pull that may well have come back empty.
    //Answers {pic, reason}; reason tells an empty pull apart from a blocked one (see
    //profilePicMessage). A server that predates the reason answers the pic string itself, so keep
    //reading that shape too — a frontend build can go live before the api restarts.
    async getProfilePic(contact, quiet) {

        let res = await apiPost('whatsapp/getProfilePic', { contactId: contact.id }, !!quiet);

        let result = (res && typeof res == 'object') ? res : { pic: res || null, reason: res ? 'ok' : 'no-picture' };

        contact.pic = result.pic;

        return result;


    },

    //Why a pull came back with nothing, in words the user can act on. 'private' is the common one
    //and used to read as "לא נמצאה תמונת פרופיל", which sent people looking for a bug: whatsapp
    //shows a profile picture only to numbers the owner has saved, so there is nothing to fix on our
    //side and no point in pressing again.
    profilePicMessage(reason) {

        if (reason == 'private')
            return 'תמונת הפרופיל מוסתרת בהגדרות הפרטיות של איש הקשר';

        if (reason == 'not-connected')
            return 'וואטסאפ אינו מחובר';

        if (reason == 'error')
            return 'לא הצלחנו למשוך את התמונה מוואטסאפ';

        return 'לא נמצאה תמונת פרופיל בוואטסאפ';

    },

    disconnect() {

        return apiPost('whatsapp/disconnect').then(res =>{
            planup.$store.state.businessSettings.whatsappServer = '';
            //explicit disconnect drops the durable "was connected" marker (server does the same),
            //so the red warnings don't nag about a connection the user chose to remove
            planup.$store.state.businessSettings.whatsappEverConnected = null;
            planup.$store.state.whatsappStatus = 'לא מחובר';
            planup.$store.state.whatsappConnected = false;
            localStorage.setItem('planupWhatsappDisconnected', '1');
        });
    },


    handleAck(messageData){


        if (this.messagesAwaitingAck[messageData.messageId])
            this.messagesAwaitingAck[messageData.messageId].gotWhatsappAck = true;

    },


    handleIncomingMessage(messageFromSocket) {


        //render both incoming (fromMe=false) and the business's own phone-sent (fromMe=true) messages


        let message = {
            msgGroup: `whatsapp_contact_${messageFromSocket.contactId}`,
            contactId: messageFromSocket.contactId,
            customerId: messageFromSocket.customerId,
            typeOfMessage:'whatsapp',
            message: messageFromSocket.body,
            //a photo / sticker: the picture itself, already on S3 (the api attaches it before
            //relaying the message)
            attachmentUrl: messageFromSocket.attachmentUrl || null,
            incomingFromCustomer: !messageFromSocket.fromMe,
            created: new Date(),

        }

        //the header whatsapp box listens for this - it refreshes an open list, and counts
        //incoming messages into its badge while closed. Emitted before the open-chat early
        //return below, so a message that lands in an open conversation still updates it
        window.planup.$root.$emit('whatsappMessageArrived', message);

        if (this.activeChats[`whatsapp_contact_${message.contactId}`]) {
                
                this.activeChats[`whatsapp_contact_${message.contactId}`].unshift(message);
                return;
        }



        window.planup.$handlers.customerHandler.getContactData(message.contactId).then(contact => {


            let picUrl = window.planup.$handlers.customerHandler.getContactImage(contact);

            let contactName = window.planup.$handlers.customerHandler.getDisplayName(contact);
            let notificationText = 'הודעה חדשה מ' + contactName;

            window.planup.$notify({
                type: `whatsapp customer${message.customerId} contact${message.contactId}`,
                title: 'hidden',
                text: `<img src="${picUrl}"><div class="whatsappMsgBody">${notificationText}</div><div style="clear:both"></div>`,
            })

        })

    },

    handleConnected() {

        console.log('Whatsapp connected');

        //socket told us we (re)connected — clear any pending "disconnected" state instantly
        planup.$store.state.whatsappStatusMisses = 0;
        planup.$store.state.whatsappConnected = true;
        localStorage.removeItem('planupWhatsappDisconnected');

        //the server persists this on the 'connected' relay — mirror it locally so the
        //warning logic is right without a reload
        if (planup.$store.state.businessSettings)
            planup.$store.state.businessSettings.whatsappEverConnected = 1;

        //a future disconnect is a new event and deserves a new popup
        sessionStorage.removeItem('planupWaDisconnectedPopupShown');

        planup.$root.$emit('whatsappConnected');

        this.offerToSendQueuedMessages();

    },


    //right after a (re)connect: if messages piled up while the account was down, offer to
    //flush them now — the server sends them one by one with a small delay between them
    offerToSendQueuedMessages() {

        axiosV2('whatsapp/queuedMessages').then(res => {

            let data = res && res.data;

            if (!data || !data.messages || !data.messages.length || data.sending)
                return;

            planup.$swal({
                title: 'הואצאפ התחבר',
                html: `בזמן שהחשבון היה מנותק נשמרו ${data.messages.length} הודעות שלא נשלחו.<br>לשלוח אותן עכשיו?`,
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'שלח עכשיו',
                cancelButtonText: 'לא כרגע',
            }).then(() => {

                apiPost('whatsapp/sendQueuedMessages', {}, true).then(() => {

                    planup.$notify({
                        type: 'success',
                        title: 'שליחת ההודעות החלה',
                        text: 'ההודעות שבתור נשלחות ברקע בהפרשים קטנים'
                    });

                    planup.$root.$emit('whatsappQueueFlushStarted');

                });

            }).catch(() => { });

        }).catch(() => { });

    },


    //baileys says the device unlinked (loggedOut) — no debounce here, it's definitive
    handleDisconnected() {

        console.log('Whatsapp disconnected');

        planup.$store.state.whatsappStatusMisses = 3;
        planup.$store.state.whatsappStatus = 'לא מחובר';
        planup.$store.state.whatsappConnected = false;
        localStorage.setItem('planupWhatsappDisconnected', '1');

        //a live disconnect is fresh news even if a popup already showed this session
        sessionStorage.removeItem('planupWaDisconnectedPopupShown');

        this.maybeShowDisconnectedPopup();

    }





}